import { render, staticRenderFns } from "./cardWriteoffList.vue?vue&type=template&id=34844060&scoped=true&"
import script from "./cardWriteoffList.vue?vue&type=script&lang=ts&"
export * from "./cardWriteoffList.vue?vue&type=script&lang=ts&"
import style0 from "./cardWriteoffList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cardWriteoffList.vue?vue&type=style&index=1&id=34844060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34844060",
  null
  
)

export default component.exports